/**
 * REWE Digital GmbH.
 * IT-Verticals
 *
 * zr-warning-notice component
 */

@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;


// component name
$component: 'zr-warning-notice';

// component vars defaults
:host {
    display: block;
}

.#{$component}__wrapper {
    padding: 16px 16px 16px 82px;
    position: relative;
    border: solid 1px var(--ci-neutral300);
    border-radius: 4px;

    ul {
        margin: 0;
        padding-left: 16px;
    }

    p {
        margin-top: 0;
        margin-bottom: 0;
        text-align: left;
    }

    &::before {
        display: inline-block;
        height: 50px;
        width: 50px;
        content: '';
        position: absolute;
        top: 16px;
        left: 16px;
        background-image: url(map-get(i.$icons, 'warning'));
        background-size: contain;
        background-repeat: no-repeat;
    }
}
